import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header-with-estate-logo"
}
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = {
  key: 0,
  class: "estate-logo-wr"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "estate-logo-wr"
}
const _hoisted_6 = {
  key: 2,
  class: "summary-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.isDesktop)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "placeholder-left" }, null, -1)),
          ($setup.props.builder?._id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: $setup.props.builder?.logo
                }, null, 8, _hoisted_4)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("div", null, "Builder Estimator", -1)
              ]))])),
          ($setup.props.currentStep !== $setup.BuilderEstimatorSteps.LAND_DETAILS && $setup.props.currentStep !== $setup.BuilderEstimatorSteps.SUMMARY)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode($setup["BuilderEstimatorQuoteSummaryMobileCollapse"], {
                  totalPrice: $props.totalPrice,
                  onToggleSummaryModal: $setup.toggleSummaryModal
                }, null, 8, ["totalPrice"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}